module.exports = __webpack_public_path__ + "static/media/check-ins-missed.96dcfd77.svg";